import React, {useEffect} from 'react';
import {
    execute,
    init,
    resetState,
  setSelectedPackage, steps, setStep, saveToHistory
} from "app/Components/Block/IdfNewPlanSignupBlock/IdfNewPlanSignupSlice";
import {connect} from "react-redux";
import SalePackages from "app/Components/Block/SalePackagesBlock/SalePackages";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import {
  createReportIdfNewPlanSignupChoosePackagePageDisplayed,
  createReportIdfNewPlanSignupContinueToStep2,
  createReportIdfNewPlanSignupSelectedPackage
} from 'app/utilities/reports/createReport';


const SelectionStep = (props) => {
    const {mainTitle, secondaryTitle} = props.iContent;
    const {packages} = props.idfNewPlanSignup;

  useEffect(() => {
    createReportIdfNewPlanSignupChoosePackagePageDisplayed(
      props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
      props.userData?.loginData.userDetails.contactNumber,
      props.userData?.loginData.userDetails.IDNumber)
      props.saveToHistory('selection');
  }, []);

  useEffect(() => {
    if (props.idfNewPlanSignup.selectedPackage) {
      createReportIdfNewPlanSignupSelectedPackage(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfNewPlanSignup.nextBpKey,
        props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
      );
    }
  }, [props.idfNewPlanSignup.selectedPackage]);

    const onSelectedPackages = (selectedPackage) => {
      props.setSelectedPackage(selectedPackage)
    };

    const handleClickContinue = () => {
      createReportIdfNewPlanSignupContinueToStep2(
        props.userData?.loginData.userDetails.firstName + ' ' + props.userData?.loginData.userDetails.lastName,
        props.userData?.loginData.userDetails.contactNumber,
        props.userData?.loginData.userDetails.IDNumber,
        props.idfNewPlanSignup.nextBpKey,
        props.idfNewPlanSignup.selectedPackage?.packageObj?.price?.value
      );
      props.setStep(steps.AGREEMENTS);
    }

  return (
<>
    <div className={'top-content'}>
        <div className={'top-text-content'}>
            <span className={"main-title"}>{mainTitle?.value}</span>
            <span className={"secondary-title"}>{secondaryTitle?.value}</span>
        </div>
    </div>
        <SalePackages
            packages={{
                //each packagesToDisplay has a package property, make sure to pass it to the SalePackages component
              expandedValue: packages?.map((item) => item.packageObj),
                isAbroadPackages: false,
            }}
            isSwiper={true}
            isHideButton={true}
            onSelectedPackages={onSelectedPackages}
            isIdf={true}
        />

  <div className={'button-container'}>
    <BtnSubmit onclick={handleClickContinue} text={"בחרתי, אפשר להתקדם"} disabled={props.idfNewPlanSignup.selectedPackage === null}/>
</div>
</>
   )
};

const mapStateToProps = (state) => {
    return {
        idfNewPlanSignup: state.idfNewPlanSignup,
        userData: state.authentication
    }
};

const mapDispatchToProps = {
    resetState,
    setSelectedPackage,
    init,
    execute,
  setStep,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionStep);
